/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorfallbackcopied2Inputs */



/**
* | output |
* | --- |
* | "✓ Copied" |
*
* @param {Errorfallbackcopied2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const errorfallbackcopied2 = /** @type {((inputs?: Errorfallbackcopied2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorfallbackcopied2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("✓ Copied")
	if (locale === "es") return /** @type {LocalizedString} */ ("✓ Copiado")
	return /** @type {LocalizedString} */ ("✓ Скопировано")
});
export { errorfallbackcopied2 as "errorFallbackCopied" }